module.exports = __webpack_public_path__ + "img/dotwhite.562457b3.svg";